export default {
  data: () => ({
    breakPoints: {
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
    innerWidth: 0,
  }),

  computed: {
    isLowerThanLg() {
      return this.innerWidth < this.breakPoints.lg;
    },
  },

  methods: {
    onResize() {
      this.innerWidth = window.innerWidth;
    },
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },

  mounted() {
    this.innerWidth = window.innerWidth;
  },

  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
};
